<script>
import { mapActions, mapGetters } from 'vuex';
import { Field, Form } from 'vee-validate';
import * as Yup from 'yup';

import VInput from '@/components/Common/VInput';
import VSelect from '@/components/Common/VSelect';

export default {
  components: {
    VInput,
    VSelect,
    VeeForm: Form,
    VeeField: Field,
  },
  data() {
    return {
      phone: null,
      name: null,
      email: null,
      dealer: null,
    };
  },
  setup() {
    const schema = Yup.object().shape({
      phone: Yup.string().required(),
      name: Yup.string().required(),
      email: Yup.string().email(),
    });

    const schemaDealers = Yup.object().shape({
      phone: Yup.string().required(),
      name: Yup.string().required(),
      email: Yup.string().email(),
      dealer: Yup.mixed().nullable(false).required(),
    });

    return {
      schema,
      schemaDealers,
    };
  },
  computed: {
    ...mapGetters({
      allShowedOverlays: 'Popups/allShowedOverlays',
      titlePopup: 'Popups/titlePopup',
      buttonPopup: 'Popups/buttonPopup',
      popupData: 'Popups/popupData',
    }),

    formData() {
      let formData = null;

      formData = {
        name: this.name,
        phone: this.phone,
        email: this.email,
        dealer_id: this.popupData?.dealerId || this.dealers.id,
        action: this.popupData?.action,
        stock: this.popupData?.stock,
        car_id: this.popupData?.carId,
      };

      if (this.popupData?.header) {
        formData.header = this.popupData.header;
      }

      return formData;
    },
    isShowedPopup() {
      return this.allShowedOverlays?.includes('order-call-dealers');
    },
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      send: 'FormData/send',
    }),

    onSubmit(value, actions) {
      this.send(this.formData);

      this.closePopup();
      this.togglePopup('popup-message');

      this.reset();
      setTimeout(() => {
        actions.resetForm();
      }, 1000);
    },
    closePopup() {
      this.togglePopup('order-call-dealers');
    },
    reset() {
      this.name = null;
      this.phone = null;
      this.email = null;
      this.dealer = null;
    },
  },
};
</script>

<template>
  <div
    class="popup-new"
    :class="{ 'opacity-100 visible': isShowedPopup }"
    @click.self="closePopup"
  >
    <div class="popup-new-inner">
      <div class="w-full">
        <div class="flex items-center justify-between mb-2.5 md:mb-5">
          <img
            src="/public/images/logo.svg"
            alt=""
            class="w-full max-w-[186px] h-[41px] pr-2"
          >
          <div
            class="popup-new__close"
            @click="closePopup"
          ></div>
        </div>
        <div class="relative">
          <p
            v-html="titlePopup || 'Заказать звонок'"
            class="title-h2 mb-6 !text-2xl pr-2"
          ></p>
          <div class="mb-8">
            <vee-form
              class="grid grid-cols-1 gap-6 mt-7"
              :validation-schema="this.popupData?.dealerId ? schema : schemaDealers"
              @submit="onSubmit"
            >
              <vee-field
                v-slot="{ handleChange, errorMessage }"
                name="phone"
              >
                <v-input
                  v-model="phone"
                  placeholder="+7 (___) ___-__-__"
                  theme="white"
                  format="phone"
                  inscription="Ваш телефон*"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <vee-field
                v-slot="{ handleChange, errorMessage }"
                name="name"
              >
                <v-input
                  v-model="name"
                  placeholder="Введите ФИО"
                  theme="white"
                  inscription="Контактное лицо*"
                  format="name"
                  name="name"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <vee-field
                v-slot="{ handleChange, errorMessage }"
                name="email"
              >
                <v-input
                  v-model="email"
                  placeholder="Введите почту"
                  theme="white"
                  inscription="E-mail"
                  format="email"
                  name="e-mail"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <vee-field
                v-if="!this.popupData?.dealerId"
                v-slot="{ handleChange, errorMessage }"
                name="dealer"
              >
                <v-select
                  v-model="dealer"
                  :options="this.popupData?.dealers"
                  placeholder="Укажите дилерский центр"
                  inscription="Дилерский центр*"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <button
                type="submit"
                class="col-auto button button_green button_big w-full"
                v-html="buttonPopup || 'Заказать звонок'"
              ></button>
              <div class="text-center">
                Я даю согласие группе компаний «Прагматика» на
                <a
                  href="/agreement/"
                  target="_blank"
                  class="text-green hover:underline transition ease-in-out duration-200"
                >обработку моих персональных данных.</a>
              </div>
            </vee-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
